import * as React from "react";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { type RawReportData } from "../../../Utilities/Platform/Reports";
import UnescapedContent from "../../Misc/UnescapedContent";
import { type ReportGroupData } from "./ReportTable";
import ReportTableGroupIndicator from "./ReportTableGroupIndicator";

interface Props {
    type: "item" | "group" | "total";
    data: RawReportData;
    depth: number;
    columns: Array<string>;
    parentGroups: Array<string>;
    groups: ReportGroupData;
    onClick: (type: string, data: RawReportData, groups: Array<string>) => void;
    nullName: string;
    columnClasses: Record<string, string>;
    layers?: number;
    nullGroupNames: Array<string>;
}

export default class ReportTableRow extends React.Component<Props> {
    public static defaultProps = {
        nullName: "",
    };

    protected handleClick = (): void => {
        this.props.onClick(this.props.type, this.props.data, this.props.parentGroups);
    };

    public render(): React.ReactNode {
        const indicator = <ReportTableGroupIndicator layer={this.props.depth} type={this.props.type} />;
        const style = {
            paddingLeft: (this.props.depth * 32 + 10) + "px",
        };

        if(this.props.type === "group") {
            let parentLayer = {
                children: this.props.groups,
            };

            for(let i = 0, l = this.props.parentGroups.length; i < l; i++) {
                parentLayer = parentLayer.children[this.props.parentGroups[i]];
            }

            const currentGroup = parentLayer.children[(this.props.data.name ? this.props.data.name : "")];

            const open = (currentGroup ? currentGroup.open : true);

            let showIcon = true;

            if(typeof this.props.layers === "number") {
                showIcon = this.props.depth !== this.props.layers;
            }

            const classes = [ "report-table-group-text" ];

            let name = this.props.data.name;

            if(!name && typeof this.props.layers === "number") {
                classes.push("no-name");

                if(this.props.layers === 0 && this.props.nullName === "" && this.props.nullGroupNames.length !== 0) {
                    name = this.props.nullGroupNames[0];
                } else {
                    name = this.props.nullGroupNames[Math.max(this.props.layers - 1, 0)];
                }
            }

            return (
                <tr className="report-table-group">
                    <td
                        colSpan={this.props.columns.length}
                        onClick={this.handleClick}
                    >
                        <span className={classes.join(" ")}>
                            {indicator}
                            <div
                                style={{
                                    paddingLeft: (this.props.depth * 32) + "px",
                                    display    : "inline-block",
                                }}
                            >
                                {showIcon && <FontAwesomeLight icon={open ? "caret-down" : "caret-right"} />}
                                {name}
                            </div>
                        </span>
                    </td>
                </tr>
            );
        } else {
            return (
                <tr className={"report-table-" + this.props.type}>
                    {this.props.columns.map((column, index) => {
                        let text: string | number | null = "";

                        if(typeof this.props.data[column as keyof RawReportData] !== "undefined") {
                            text = this.props.data[column as keyof RawReportData] as string | number;
                        }

                        const className = this.props.columnClasses[column] || "";

                        return (
                            <td
                                key={column}
                                style={(index === 0 ? style : {})}
                                className={className}
                            >
                                {index === 0 && indicator}
                                {index === 0 && text === null && this.props.type === "item" && (
                                    this.props.nullName
                                )}
                                {!(index === 0 && text === null) && (
                                    <UnescapedContent>
                                        {text === null ? "" : text.toString()}
                                    </UnescapedContent>
                                )}
                            </td>
                        );
                    })}
                </tr>
            );
        }
    }
}
